import sideImage from "../images/afro-solar/power-solution/side-image-2.webp";

const PowerSolution = () => {
  return (
    <div className="container-fluid mt-7" id="power-solutions">
      <h1 className="fs-56 lh-64 gilroy-bold text-center pt-5">
        POWER <span className="text-orange-ryb">SOLUTIONS</span>
      </h1>
      <p className="fs-18 text-center">
        We provide all solutions that suit your business.
      </p>
      <div className="row me-13 ms-13 pt-5">
        <div className="col-12 col-xl-6 px-4 py-5 my-auto">
          <div className="my-5">
            <h3 className="fs-18 gilroy-bold">Off-Grid Systems</h3>
            <p className="fs-16 lh-30 text-align-justify">
              Solar radiation from the sun is captured by solar panels, which
              produce DC electricity. Then a charge controller convert this
              unregulated DC power into regulated DC power to store batteries
              The batteries are connected to an inverter which converts the DC
              electricity into AC electricity which can be used directly to
              power AC loads and appliances.
            </p>
          </div>
          <div className="my-5">
            <h3 className="fs-18 gilroy-bold">ON-Grid Systems</h3>
            <p className="fs-16 lh-30 text-align-justify">
              Is a solar power generation system which feeds the generated power
              into the grid, through a special on-grid inverter. Grid connected
              systems vary in size from residential (2-10kWp) to solar power
              stations (up to 10s of MWP). In the case of residential or
              building mounted grid connected PV systems, the electricity demand
              of the building is met by the PV system. Only the excess is fed
              into the public grid.
            </p>
          </div>
          <div className="my-5">
            <h3 className="fs-18 gilroy-bold">Hybrid solution (PV + Diesel)</h3>
            <p className="fs-16 lh-30 text-align-justify">
              Hybrid means seamlessly blending solar power with grid or
              generator power sources. Dynamic combination of power sources, so
              that the pumping system operates at its full load utilizing the
              solar power and minimizing the dependence on non-renewable power
              sources.
            </p>
          </div>
        </div>
        <div className="col-12 col-xl-6">
          <img src={sideImage} alt="side" className="img-fluid" />
        </div>
      </div>
    </div>
  );
};

export default PowerSolution;
